import Link from 'next/link';

import cx from 'classnames';
import useDynamicFontSize from 'themes/canvas/components/utils';

import s from './ZenHero.module.css';

interface HeroProps {
  imgSrc: string;
  businessName: string;
  bookNowLinkUrl: string;
}

export const ZenHero: React.FC<HeroProps> = ({
  imgSrc,
  businessName,
  bookNowLinkUrl,
}) => {
  const { containerRef, fontSize, nowrapClass } =
    useDynamicFontSize(businessName);

  const businessNameStyle: React.CSSProperties = {
    fontSize: fontSize ? `${fontSize}px` : 'inherit',
  };

  return (
    <section className={s.root}>
      <div className={s.heroContainer}>
        <div className={cx(s.businessName, nowrapClass ? s.nowrapClass : '')}>
          <h1 ref={containerRef} style={businessNameStyle}>
            {businessName}
          </h1>
          <Link href={bookNowLinkUrl}>Book Now</Link>
        </div>
        <div
          className={s.heroContent}
          style={{
            backgroundImage: `url(${imgSrc})`,
          }}
        ></div>
      </div>
    </section>
  );
};
